export function normalizeKoreanPhone(input) {
    if (!input) return '';
    let p = String(input).replace(/\D/g, ''); // 숫자만

    // +82 / 82 로 시작하면 국내 0 시작 번호로 변환
    if (p.startsWith('82')) {
        p = '0' + p.slice(2);
    }

    return p;
}

export function phoneToEmail(phone) {
    const p = normalizeKoreanPhone(phone);
    return `${p}@floater.kr`;
}
